module.exports = __webpack_public_path__ + "static/media/tanmayee.abc671a5.jpg";